import { getPostsForCategory, getPostBySlugWithSEO } from '@/lib/blog/post'

export async function getNewsletterPosts() {
  const { category } = await getPostsForCategory('newsletter')
  return category?.posts?.nodes ?? []
}

export async function getNewsletterBySlugWithSEO(slug) {
  return getPostBySlugWithSEO(slug)
}

export function getNewsletterYearMonth(post) {
  return new Date(post.date).toISOString().slice(0, 7)
}

export async function getNewsletterByMonth(yearMonth) {
  const posts = await getNewsletterPosts()
  return posts.find(post => getNewsletterYearMonth(post) === yearMonth) ?? null
}
